<template>
    <div>
        <div v-auto-animate>
            <div
                class="rounded-md border-iron-200 px-4 py-2 flex items-center justify-between border"
            >
                <div>
                    <p class="font-semibold text-iron-600">
                        {{ title }}
                    </p>

                    <p class="text-sm">
                        {{ assignedWorkflows?.length }}
                        {{
                            $t(
                                "workflows.steps.active",
                                assignedWorkflows?.length,
                            )
                        }}
                        {{
                            $t(
                                "workflows.steps.workflows",
                                assignedWorkflows?.length,
                            )
                        }}
                    </p>
                </div>
                <div>
                    <Button
                        @click="opened = !opened"
                        size="sm"
                        variant="outline"
                    >
                        <ChevronDown
                            class="transition-all duration-150"
                            :class="[opened ? 'rotate-180' : '']"
                            :size="16"
                        />
                    </Button>
                </div>
            </div>

            <div v-if="!opened">
                <div v-if="!isLast" class="flex w-full justify-center">
                    <div class="h-4 bg-iron-200 flex w-[1px]"></div>
                </div>
            </div>
            <div v-auto-animate v-if="opened">
                <div
                    class="px-4"
                    v-for="workflow of assignedWorkflows"
                    :key="workflow.id"
                >
                    <div>
                        <div class="flex w-full justify-center">
                            <div class="h-4 bg-iron-200 flex w-[1px]"></div>
                        </div>

                        <div
                            class="group rounded-md border-iron-200 px-4 py-2 border"
                        >
                            <div
                                class="gap-1.5 flex items-center justify-between"
                            >
                                <div class="flex">
                                    <div
                                        v-if="workflow.action === 'send_email'"
                                    >
                                        <Mail
                                            class="text-iron-600"
                                            :size="20"
                                        ></Mail>
                                    </div>

                                    <div
                                        v-if="
                                            workflow.action === 'send_webhook'
                                        "
                                    >
                                        <Webhook :size="18" />
                                    </div>
                                    <div>
                                        <p
                                            class="ml-2 text-sm font-medium text-iron-700"
                                        >
                                            <template
                                                v-if="
                                                    workflow.action ===
                                                    'send_webhook'
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "workflows.workflow_item.webhook_with_name",
                                                        { name: workflow.name },
                                                    )
                                                }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    workflow.target ===
                                                    "attendees"
                                                        ? $t(
                                                              "workflows.targets.attendees",
                                                          )
                                                        : $t(
                                                              "workflows.targets.host",
                                                          )
                                                }}
                                                - {{ workflow.name }}
                                            </template>
                                        </p>
                                        <p
                                            v-if="workflow.data"
                                            class="ml-2 text-sm font-medium text-iron-700"
                                        >
                                            <span
                                                v-if="
                                                    JSON.parse(workflow.data)
                                                        ?.timeBefore
                                                "
                                            >
                                                -
                                                {{
                                                    JSON.parse(workflow.data)
                                                        ?.timeBefore /
                                                    60 /
                                                    60
                                                }}
                                                {{
                                                    $t(
                                                        "workflows.hours",
                                                        JSON.parse(
                                                            workflow.data,
                                                        )?.timeBefore /
                                                            60 /
                                                            60,
                                                    )
                                                }}
                                                {{
                                                    $t(
                                                        "workflows.before_suffix",
                                                    )
                                                }}</span
                                            >
                                        </p>
                                    </div>
                                </div>

                                <div v-auto-animate class="gap-3 flex">
                                    <Link
                                        v-if="workflow.action === 'send_email'"
                                        :href="
                                            ziggyRoute('app.workflows.show', {
                                                workflow: workflow.id,
                                            }) + `?event-type=${eventType.id}`
                                        "
                                    >
                                        <Pencil
                                            class="text-iron-900 ease-out opacity-0 transition-all duration-100 group-hover:block group-hover:opacity-100"
                                            :size="18"
                                        >
                                        </Pencil>
                                    </Link>
                                    <button
                                        :disabled="!isOwner"
                                        @click="
                                            emit('detachWorkflow', workflow.id)
                                        "
                                    >
                                        <Trash2
                                            class="ease-out opacity-0 transition-all duration-100 group-hover:block group-hover:opacity-100"
                                            :class="
                                                !isOwner
                                                    ? 'text-iron-300 cursor-not-allowed'
                                                    : 'text-iron-900'
                                            "
                                            :size="18"
                                        >
                                        </Trash2>
                                    </button>
                                </div>
                            </div>
                            <div
                                v-if="
                                    eventType.isTeamEventType &&
                                    isWorkflowShared(workflow) &&
                                    !isWorkflowOwnedByCurrentUser(workflow)
                                "
                                class="ml-7 mt-1.5 gap-2 flex items-center"
                            >
                                <Checkbox :checked="true" disabled />
                                <label class="text-xs text-iron-500">
                                    {{ $t("workflows.shared_with_you") }}
                                </label>
                            </div>
                            <div
                                v-else-if="
                                    canShareWorkflows &&
                                    eventType.isTeamEventType
                                "
                                class="ml-7 mt-1.5 gap-2 flex items-center"
                            >
                                <Checkbox
                                    :checked="isWorkflowShared(workflow)"
                                    @update:checked="
                                        emit('toggleShared', workflow.id)
                                    "
                                />
                                <label
                                    class="text-xs text-iron-500 cursor-pointer"
                                    @click="emit('toggleShared', workflow.id)"
                                >
                                    {{ $t("workflows.shared_with_team") }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex w-full justify-center">
                    <div class="h-4 bg-iron-200 flex w-[1px]"></div>
                </div>

                <!-- Show when subscription is not present -->
                <div
                    v-if="
                        !hasSubscription &&
                        trigger === 'reservation_will_happen_in'
                    "
                    class="relative flex justify-center"
                >
                    <button
                        @click="proDialog.show({ feature: 'custom_workflow' })"
                    >
                        <Plus
                            class="rounded-md bg-stone-100 text-stone-300 ease-in group-hover:bg-z-primary-50 transition-all duration-150 group-hover:scale-125"
                            :size="24"
                            :stroke-width="2.2"
                        ></Plus>
                        <PaidFeatureIcon
                            class="-top-1.5 absolute left-[51%]"
                        ></PaidFeatureIcon>
                    </button>
                </div>
                <!-- Show when sub is present and user not owner of the team -->
                <div v-else-if="!isOwner" class="relative flex justify-center">
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger
                                ><button disabled>
                                    <Plus
                                        class="rounded-md bg-stone-100 text-stone-300 ease-in group-hover:bg-z-primary-50 cursor-not-allowed transition-all duration-150 group-hover:scale-125"
                                        :size="24"
                                        :stroke-width="2.2"
                                    ></Plus>
                                </button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{{ $t("workflows.team_owner_only") }}</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
                <!-- Show when subscription is present && when in team user is owner of the team -->
                <div v-else class="flex justify-center">
                    <DropdownMenu>
                        <DropdownMenuTrigger as-child>
                            <button class="group">
                                <Plus
                                    class="rounded-md text-z-primary-500 ease-in group-hover:bg-z-primary-50 transition-all duration-150 group-hover:scale-125"
                                    :size="24"
                                    :stroke-width="2.2"
                                ></Plus>
                            </button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent class="w-56">
                            <DropdownMenuGroup>
                                <DropdownMenuSub>
                                    <DropdownMenuSubTrigger>
                                        <Mail class="mr-1 h-4 w-4" />
                                        <span
                                            >Email ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "send_email",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'send_email',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>
                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'send_email',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'send_email',
                                                    })
                                                "
                                            >
                                                <Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="integrationTypes.includes('WEBHOOK')"
                                >
                                    <DropdownMenuSubTrigger>
                                        <span>
                                            Webhook ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "send_webhook",
                                                ).length
                                            }})
                                        </span>
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'send_webhook',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'send_webhook',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'send_webhook',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('FREELO') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Freelo ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_task_to_freelo",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_task_to_freelo',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_task_to_freelo',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_task_to_freelo',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />

                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('ECOMAIL') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Ecomail ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_contact_to_ecomail",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_contact_to_ecomail',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>
                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_contact_to_ecomail',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_contact_to_ecomail',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />

                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>
                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('CLOSE') &&
                                        trigger === 'reservation_made'
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Close ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "sync_to_close",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'sync_to_close',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'sync_to_close',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'sync_to_close',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />

                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="integrationTypes.includes('SLACK')"
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Slack ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "send_to_slack",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'send_to_slack',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'send_to_slack',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'send_to_slack',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>
                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('RAYNET') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Raynet ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_lead_to_raynet",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_lead_to_raynet',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>
                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_lead_to_raynet',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_lead_to_raynet',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes(
                                            'PIPEDRIVE',
                                        ) &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Pipedrive ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_person_to_pipedrive",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_person_to_pipedrive',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>

                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_person_to_pipedrive',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_person_to_pipedrive',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>

                                <DropdownMenuSub
                                    v-if="
                                        integrationTypes.includes('HUBSPOT') &&
                                        ![
                                            'reservation_canceled',
                                            'reservation_will_happen_in',
                                        ].includes(trigger)
                                    "
                                >
                                    <DropdownMenuSubTrigger>
                                        <span
                                            >Hubspot ({{
                                                filterWorkflows(
                                                    unassignedWorkflows,
                                                    "add_contact_to_hubspot",
                                                ).length
                                            }})</span
                                        >
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuPortal>
                                        <DropdownMenuSubContent>
                                            <DropdownMenuItem
                                                v-for="workflows of filterWorkflows(
                                                    unassignedWorkflows,
                                                    'add_contact_to_hubspot',
                                                )"
                                                :key="workflows.id"
                                                @click="
                                                    emit(
                                                        'assignWorkflow',
                                                        workflows.id,
                                                    )
                                                "
                                            >
                                                {{ workflows.name }}
                                            </DropdownMenuItem>
                                            <DropdownMenuSeparator
                                                v-if="
                                                    filterWorkflows(
                                                        unassignedWorkflows,
                                                        'add_contact_to_hubspot',
                                                    ).length > 0
                                                "
                                            />

                                            <DropdownMenuItem
                                                class="gap-1"
                                                @click="
                                                    openWorkflowCreation({
                                                        action: 'add_contact_to_hubspot',
                                                    })
                                                "
                                                ><Plus
                                                    :size="16"
                                                    class="text-iron-600"
                                                />
                                                {{ $t("workflows.create_new") }}
                                            </DropdownMenuItem>
                                        </DropdownMenuSubContent>
                                    </DropdownMenuPortal>
                                </DropdownMenuSub>
                            </DropdownMenuGroup>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
                <div v-if="!isLast" class="flex w-full justify-center">
                    <div class="h-4 bg-iron-200 flex w-[1px]"></div>
                </div>
            </div>
        </div>
        <CreateWorkflowModal
            v-if="
                createWorkflowModalData.action &&
                createWorkflowModalData.trigger
            "
            :default-opened="true"
            :integrations="integrations"
            :preselected-action="createWorkflowModalData.action"
            :preselected-trigger="createWorkflowModalData.trigger"
            :event-type="eventType"
            @onClosed="
                () =>
                    (createWorkflowModalData = {
                        action: null,
                        trigger: null,
                    })
            "
        ></CreateWorkflowModal>
    </div>
</template>

<script setup lang="ts">
import type { Workflow } from "../../../Workflows/components/Workflow.vue";
import CreateWorkflowModal from "../../../Workflows/components/CreateWorkflowModal.vue";
import { ref, computed } from "vue";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuPortal,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
    DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import {
    Mail,
    Plus,
    Trash2,
    ChevronDown,
    Pencil,
    Webhook,
} from "lucide-vue-next";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { vAutoAnimate } from "@formkit/auto-animate";
import type { EventType } from "../../types/EventType";
import { useHasSubscription } from "@/composables/useHasSubscription";
import PaidFeatureIcon from "../../../Atomic/PaidFeatureIcon.vue";
import useProDialog from "@/ProModal/composables/useProDialog";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

import { Link } from "@inertiajs/vue3";
import route from "ziggy-js";
const ziggyRoute = route;

const props = defineProps<{
    title: string;
    assignedWorkflows: Workflow[];
    unassignedWorkflows: Workflow[];
    isLast?: boolean;
    integrations: any[];
    eventType: EventType & { workflows?: any[] };
    isOwner: boolean;
    canShareWorkflows: boolean;
    currentUserPersonalTeamId: number;
    trigger:
        | "reservation_made"
        | "reservation_canceled"
        | "reservation_will_happen_in";
}>();

const emit = defineEmits(["assignWorkflow", "detachWorkflow", "toggleShared"]);

const isWorkflowShared = (workflow: Workflow) => {
    const assigned = props.eventType.workflows?.find(
        (w: any) => w.id === workflow.id,
    );
    return assigned?.pivot?.user_id === null;
};
const isWorkflowOwnedByCurrentUser = (workflow: Workflow) =>
    workflow.team_id === props.currentUserPersonalTeamId;
const opened = ref(true);
type Action =
    | "send_email"
    | "add_task_to_freelo"
    | "add_contact_to_ecomail"
    | "sync_to_close"
    | "send_to_slack"
    | "add_lead_to_raynet"
    | "add_person_to_pipedrive"
    | "add_contact_to_hubspot"
    | "send_webhook";

type WorkflowModalData = {
    action: Action | null;
    trigger:
        | "reservation_made"
        | "reservation_canceled"
        | "reservation_will_happen_in"
        | null;
};

const { hasSubscription } = useHasSubscription(props.eventType);
const proDialog = useProDialog();
const createWorkflowModalData = ref<WorkflowModalData>({
    action: null,
    trigger: null,
});

const integrationTypes = computed(() => {
    return props.integrations.map((integration) => integration.type);
});

function filterWorkflows(workflows: Workflow[], action: Action) {
    return workflows.filter((workflow) => workflow.action === action);
}

function openWorkflowCreation({ action }: { action: Action }) {
    createWorkflowModalData.value.action = action;
    createWorkflowModalData.value.trigger = props.trigger;
}
</script>
